import React, { useEffect, useState, useRef, memo } from 'react';
export const DoubleBanner = memo(function DoubleBanner() {
  const banners = [{
    id: 1,
    title: 'BANNER SIZE',
    subtitle: 'DIMENSIONS',
    description: '50% width (desktop) | 100% width (mobile)',
    bgColor: 'bg-gray-300',
    buttonText: 'Ratio 16:9'
  }, {
    id: 2,
    title: 'BANNER SIZE',
    subtitle: 'DIMENSIONS',
    description: '50% width (desktop) | 100% width (mobile)',
    bgColor: 'bg-gray-300',
    buttonText: 'Ratio 16:9'
  }];
  const scrollerRef = useRef<HTMLDivElement>(null);
  const [activePage, setActivePage] = useState(0);
  const CARDS_PER_PAGE_MOBILE = 1;
  const totalPages = Math.ceil(banners.length / CARDS_PER_PAGE_MOBILE);
  const handleScroll = () => {
    const el = scrollerRef.current;
    if (!el) return;
    const page = Math.round(el.scrollLeft / el.clientWidth);
    setActivePage(page);
  };
  const goToPage = (page: number) => {
    const el = scrollerRef.current;
    if (!el) return;
    el.scrollTo({
      left: page * el.clientWidth,
      behavior: 'smooth'
    });
  };
  useEffect(() => {
    const el = scrollerRef.current;
    if (!el) return;
    el.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => el.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className="container mx-auto px-4" data-id="element-2205" data-mp="2m0hpfijf0f6w">
      {/* Desktop: Side by side */}
      <div className="hidden md:flex flex-row gap-4" data-id="element-2206" data-mp="30pdtl4icp828">
        {banners.map(banner => <div key={banner.id} className={`w-1/2 rounded-lg overflow-hidden relative ${banner.bgColor}`} data-id="element-2207" data-mp="2vqj6hqdcoxcb">
            <div className="w-full h-60" data-id="element-2208" data-mp="39p0zo3m0z21m"></div>
            <div className="absolute inset-0 flex flex-col justify-center p-8 text-gray-800" data-id="element-2209" data-mp="35qthr5ftruou">
              <span className="text-sm font-bold bg-white text-gray-600 px-3 py-1 rounded-full w-max mb-3" data-id="element-2210" data-mp="1fckm0hqwglmq">
                {banner.subtitle}
              </span>
              <h2 className="text-3xl font-bold mb-2" data-id="element-2211" data-mp="3agiklq7w65lc">{banner.title}</h2>
              <p className="text-base font-medium mb-4 max-w-xs" data-id="element-2212" data-mp="3aibrn6mf2rtv">
                {banner.description}
              </p>
              <button className="bg-white hover:bg-gray-100 text-gray-700 font-bold py-2 px-6 rounded-md w-max text-base" data-id="element-2213" data-mp="3fhexgta8122w">
                {banner.buttonText}
              </button>
            </div>
          </div>)}
      </div>

      {/* Mobile: Paginated Slider */}
      <div className="md:hidden" data-id="element-2214" data-mp="3tf39dbmb8yvt">
        <div ref={scrollerRef} className="flex overflow-x-auto snap-x snap-mandatory scrollbar-hide" data-id="element-2215" data-mp="2922lf9dorfz">
          {Array.from({
          length: totalPages
        }).map((_, pageIdx) => {
          const pageItems = banners.slice(pageIdx * CARDS_PER_PAGE_MOBILE, pageIdx * CARDS_PER_PAGE_MOBILE + CARDS_PER_PAGE_MOBILE);
          return <div key={pageIdx} className="flex-shrink-0 w-full snap-start px-1" data-id="element-2216" data-mp="kys0ib8fttc4" data-mpi={pageIdx}>
                {pageItems.map(banner => <div key={banner.id} className={`w-full rounded-lg overflow-hidden relative ${banner.bgColor}`} data-id="element-2217" data-mp="21g8tt4wxjuia">
                    <div className="w-full h-40" data-id="element-2218" data-mp="1wj0c15fp1shk"></div>
                    <div className="absolute inset-0 flex flex-col justify-center p-4 text-gray-800" data-id="element-2219" data-mp="1riuoa0cjoq4r">
                      <span className="text-xs font-bold bg-white text-gray-600 px-2 py-1 rounded-full w-max mb-2" data-id="element-2220" data-mp="2p4jqrwzi9a1a">
                        {banner.subtitle}
                      </span>
                      <h2 className="text-xl font-bold mb-1" data-id="element-2221" data-mp="2ff040g8o8w15">{banner.title}</h2>
                      <p className="text-xs font-medium mb-3 max-w-xs" data-id="element-2222" data-mp="2agyp87ia3ivh">
                        {banner.description}
                      </p>
                      <button className="bg-white hover:bg-gray-100 text-gray-700 font-bold py-2 px-4 rounded-md w-max text-sm" data-id="element-2223" data-mp="37xnllloglsxh">
                        {banner.buttonText}
                      </button>
                    </div>
                  </div>)}
              </div>;
        })}
        </div>

        {/* Pagination dots */}
        <div className="flex items-center justify-center gap-2 mt-4" data-id="element-2224" data-mp="2dpoqpmrhzrho">
          {Array.from({
          length: totalPages
        }).map((_, i) => <button key={i} onClick={() => goToPage(i)} aria-label={`Go to page ${i + 1}`} className={`h-2 rounded-full transition-all ${activePage === i ? 'w-6 bg-[#1E2B55]' : 'w-2 bg-gray-300 hover:bg-gray-400'}`} data-id="element-2225" data-mp="2iqcg6402w09s" data-mpi={i} />)}
        </div>
      </div>
    </div>;
});